import React from 'react';
import { useTheme, buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Skeleton from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Skeleton';

const useStyles = buildUseStyles('MessageSkeleton', (theme) => ({
  root: {
    borderRadius: theme.radius.xs,
  },
}));

const MessageSkeleton = () => {
  const theme = useTheme();
  const classes = useStyles(theme);

  return (
    <Skeleton className={classes.root} animation="wave" variant="rect" height={120} width="100%" />
  );
};

MessageSkeleton.propTypes = {
};


export default MessageSkeleton;
